module.exports = __webpack_public_path__ + "img/targetGroups.f32aab66.svg";